import {ConfigurationRegion} from "../../../../api/generated";
import {SelectOption} from "../../../elements/select/SelectDropdown";

export const configurationRegionOptions: SelectOption<ConfigurationRegion>[] =
    Object.values(ConfigurationRegion).map((region) => ({
        label: region,
        value: region
    }));
